class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    })
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach(animation => animation.play());
    } else {
      this.animations.forEach(animation => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.hoverIntentDelay = 150;

    this.addEventListener('pointerenter', this.onPointerEnter.bind(this));
    this.addEventListener('pointerleave', this.onPointerLeave.bind(this));
    this.mainDetailsToggle.querySelector('summary').addEventListener('click', this.onSummaryClick.bind(this));
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty('--header-bottom-position-desktop', `${Math.floor(this.header.getBoundingClientRect().bottom)}px`);
  }

  onPointerEnter(event) {
    if (event.pointerType === 'touch') return;

    window.clearTimeout(this.closeTimer);
    this.openTimer = window.setTimeout(() => {
      document.querySelectorAll('header-menu').forEach(menu => {
        if (menu !== this) menu.close();
      });

      this.mainDetailsToggle.setAttribute('open', '');
      this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', true);
    }, this.hoverIntentDelay);
  }

  onPointerLeave(event) {
    if (event.pointerType === 'touch') return;
    if (this.contains(document.activeElement)) return;

    window.clearTimeout(this.openTimer);
    this.closeTimer = window.setTimeout(() => this.close(), 100);
  }

  onSummaryClick(event) {
    if (event.detail === 0) return;
    if (!this.mainDetailsToggle.open) return;

    event.preventDefault();
  }
}

customElements.define('header-menu', HeaderMenu);
